import { DashboardGlobalDto, DashboardParcDto } from "src/api/models"

export interface DashboardState {
  globalData: DashboardGlobalDto;
  parcData: DashboardParcDto;
  error: string;
}

export const DashboardStateDefault = {
  globalData: null,
  parcData:  null,
  error: null
}